import React from 'react'

interface CheckoutNavigationButtonsProps {
  currentStep: number
  showPaymentForm: boolean
  paymentProcessed: boolean
  setCurrentStep: (step: number) => void
  setShowPaymentForm: (show: boolean) => void
  handleContinueToNextStep: () => Promise<void>
  handlePlaceOrder: () => void
  handles: Record<string, string>
}

export const CheckoutNavigationButtons: React.FC<CheckoutNavigationButtonsProps> = ({
  currentStep,
  showPaymentForm,
  paymentProcessed,
  setCurrentStep,
  setShowPaymentForm,
  handleContinueToNextStep,
  handlePlaceOrder,
  handles
}) => {
  return (
    <div className={`${handles.checkoutActions} flex justify-between mt-8`}>
      {currentStep > 1 && !showPaymentForm && (
        <button
          onClick={() => {
            setCurrentStep(currentStep - 1)
            setShowPaymentForm(false)
          }}
          className={`${handles.backButton} bg-gray-300 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-400 transition-colors`}
        >
          Voltar
        </button>
      )}

      {currentStep === 2 ? (
        <button
          onClick={handleContinueToNextStep}
          className={`${handles.continueButton} bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors ml-auto`}
        >
          Continuar
        </button>
      ) : currentStep === 3 && showPaymentForm && paymentProcessed ? (
        <button
          onClick={handlePlaceOrder}
          className={`${handles.placeOrderButton} bg-green-600 text-white px-8 py-2 rounded-lg hover:bg-green-700 transition-colors ml-auto`}
        >
          Finalizar Pedido
        </button>
      ) : showPaymentForm ? (
        <button
          onClick={() => setShowPaymentForm(false)}
          className={`${handles.backButton} bg-gray-300 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-400 transition-colors`}
        >
          Voltar para Revisão
        </button>
      ) : null}
    </div>
  )
}

